import { OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
var MessagePopupComponent = /** @class */ (function () {
    function MessagePopupComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.answer = "";
    }
    MessagePopupComponent.prototype.ngOnInit = function () {
    };
    MessagePopupComponent.prototype.respond = function (answer) {
        this.answer = answer;
        this.bsModalRef.hide();
    };
    return MessagePopupComponent;
}());
export { MessagePopupComponent };
